var MARKER_SQUARE =  'M22-48h-44v43h16l6 5 6-5h16z';
var MARKER_PIN =  'M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z';
var MARKER_CIRCLE =  google.maps.SymbolPath.CIRCLE;

function rad(x) {return x*Math.PI/180;}
GMaps.prototype.closestLatLng = function(latLng) {

    var lat = latLng.lat();
    var lng = latLng.lng();
    var R = 6371; // radius of earth in km
    var distance;
    var closest = -1;

    for (var i = 0; i < this.polylines.length; i ++) {
        this.polylines[i].getPath().forEach(function(poly){//can't do polyline.getPath()[i] because it's a MVCArray

            var mlat = poly.lat();
            var mlng = poly.lng();
            var dLat  = rad(mlat - lat);
            var dLong = rad(mlng - lng);

            var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                Math.cos(rad(lat)) * Math.cos(rad(lat)) * Math.sin(dLong/2) * Math.sin(dLong/2);

            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
            var d = R * c;

            if (!distance || distance > d) {
                distance = d;
                closest = poly;
            }

        });
    }

    return closest;
};


var PMaps = function(options) {

    if (!options) options = {};

    this._markerBounds = new google.maps.LatLngBounds();
    this.markers = [];

    options.polylines = options.polylines || get('map.data', [], true);
    options.markers = options.markers || get('map.markers', []);
    options.polygons = options.polygons || get('map.polygons', []);

    options.debug = options.debug || get('map.debug', false);

    options.map = options.map || {};
    options.readOnly = options.readOnly || get('map.readOnly', true);
    options.markersEnabled = options.markersEnabled || get('map.markersEnabled', true);
    options.map.div = options.map.div || '#map';
    options.map.lat = options.map.lat || get('map.lat', 54.559322);
    options.map.lng = options.map.lng || get('map.lng', -4.174804);
    options.map.zoom = options.map.zoom || get('map.zoom', 5);
    options.map.styles = options.map.styles || get('map.style', null);
    options.map.maxZoom = options.map.maxZoom || get('map.maxZoom', 12);
    options.map.minZoom = options.map.minZoom || get('map.minZoom', 5);
    options.zoomToMarkers = options.zoomToMarkers || get('map.zoomToMarkers', true);
    this.options = options;

    this.map = new GMaps(this.options.map);

    if (this.options.polylines) {
        this.renderPolylines();
    }

    if (this.options.polygons) {
        this.renderPolygons();
    }

    if (this.options.markersEnabled && this.options.markers.length > 0) {
        for (var i = 0; i < this.options.markers.length; i++) {
            this.markers.push(this.renderMarker(this.options.markers[i]));
        }

        if (this.options.zoomToMarkers) this.map.fitBounds(this._markerBounds);

        // google.maps.event.addListenerOnce(this.map.map, "idle", function () {
        //     this.map.setOptions({maxZoom: this.options.map.maxZoom});
        // }.bind(this));
    }

    return this;

};

PMaps.prototype.renderPolylines = function() {
    var polylines = this.options.polylines,
        bounds = new google.maps.LatLngBounds();

    for (var i=0; i < polylines.length; i++) {
        for (var i2 = 0; i2 < polylines[i].polylines.length; i2++) {

            var poly = this.map.drawPolyline({
                path: polylines[i].polylines[i2],
                strokeColor: this.options.debug ? '#'+Math.floor(Math.random()*16777215).toString(16) : '#0088FF',
                strokeOpacity: 1,
                strokeWeight: 2
            });
            poly.getPath().forEach(function (e) {
                bounds.extend(e);
            });
        }
    }

    if (!this.options.markersEnabled || this.options.markers.length == 0 || !this.options.zoomToMarkers ) this.map.fitBounds(bounds);

};

PMaps.prototype.renderPolygons = function () {
    var polygon;
    var self = this;
    for(var i = 0; i < this.options.polygons.length; i++) {

        polygon = self.options.polygons[i];

        (function(polygon) {

            var gPoly = self.map.drawPolygon({
                paths: polygon.path,
                strokeOpacity: 0,
                fillColor: '#f0ad4e',
                fillOpacity: 0,
                click: function (e) {
                    window.location.href = polygon.href;
                },
                mouseover: function (e) {
                    this.setOptions({fillOpacity: 0.5});
                    $('#sub-areas').addClass('hover');
                    $("[href='" + polygon.href + "']").addClass('active');
                    $('#area-map-label').removeClass('hide');
                    $('#area-map-label').text(polygon.name);
                },
                mouseout: function (e) {
                    this.setOptions({fillOpacity: 0});
                    $('#sub-areas').removeClass('hover');
                    $("[href='" + polygon.href + "']").removeClass('active');
                    $('#area-map-label').addClass('hide');
                }
            });

        })(polygon);

    }
};

PMaps.prototype.renderMarker = function(marker) {

    if (!marker.path) marker.path = 'pin';

    var scale = 1;
    if (marker.path == 'circle') scale = 10;

    var path = 'MARKER_' + marker.path.toUpperCase();

    path = window[path];

    var gMarker = {
        path: path,
        fillColor: marker.fillColor || '#f0ad4e',
        fillOpacity: 0.8,
        scale: scale,
        strokeColor: marker.strokeColor || '#ed9d2b',
        strokeWeight: 2
    };

    var clickEvent = null;

    if (marker.href) {
        clickEvent = function() {
            window.location = marker.href;
        };
    }

    var pin = $.extend(this.map.addMarker({
        lat: marker.lat,
        lng: marker.lng,
        draggable: !this.options.readOnly,
        icon: gMarker,
        click: clickEvent,
        mouseover: function (e) {
            this.setOptions({fillOpacity: 0.5});
            if (marker.title) {
                $('#area-map-label').removeClass('hide');
                $('#area-map-label').text(marker.title);
            }
        },
        mouseout: function (e) {
            this.setOptions({fillOpacity: 0});
            $('#area-map-label').addClass('hide');
        }
    }), {
        changeColor: function(icon) {
            var newIcon = {};
            if (icon === undefined) { icon = {}; }
            newIcon.fillColor = icon.fillColor || gMarker.fillColor;
            newIcon.path = icon.path || gMarker.path;
            newIcon.fillColor = icon.fillColor || gMarker.fillColor;
            newIcon.fillOpacity = icon.fillOpacity || gMarker.fillOpacity;
            newIcon.scale = icon.scale || gMarker.scale;
            newIcon.strokeColor = icon.strokeColor || gMarker.strokeColor;
            newIcon.strokeWeight = icon.strokeWeight || gMarker.strokeWeight;
            this.setIcon(newIcon);
        },
        slug: marker.slug
    });

    this._markerBounds.extend(pin.getPosition());

    return pin;
};

PMaps.prototype.getMarkers = function() {
    return this.markers;
};